<template>
  <b-field class="full-width" grouped group-multiline>
    <b-field expanded class="control">
      <b-pagination
        v-model="pNumber"
        rounded
        :total="total"
        :range-before="2"
        :range-after="2"
        order="is-centered"
        :size="size"
        :per-page="documentsPerPage"
        @change="$emit('update:pageNumber', $event)" />
    </b-field>
    <b-field class="control">
      <b-dropdown
        v-model="docsPerPage"
        position="is-bottom-left"
        append-to-body
        aria-role="list"
        :mobile-modal="false"
        @input="$emit('update:documentsPerPage', $event)">
        <template #trigger="{ active }">
          <b-button
            type="is-primary"
            size="is-small"
            :label="`${ itemsName } por página: ${documentsPerPage }`"
            rounded
            :icon-right="active ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
            @submit.prevent="" />
        </template>
        <b-dropdown-item
          v-for="option in documentsPerPageOptions"
          :key="option"
          :value="option"
          aria-role="listitem">
          <span>{{ option }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-field>
  </b-field>
</template>

<script>
export default {
  name: 'CredituPagination',
  props: {
    size: { type: String, default: 'is-small' },
    documentsPerPage: { type: Number, default: 10 },
    itemsName: { type: String, default: '' },
    pageNumber: { type: Number, default: 1 },
    total: { type: Number, default: 0 },
    rangeBefore: { type: Number, default: 1 },
    rangeAfter: { type: Number, default: 1 },
    documentsPerPageOptions: { type: Array, default: () => [10, 20, 50] }
  },
  data() {
    return {
      pNumber: this.pageNumber,
      docsPerPage: this.documentsPerPage
    };
  }
};
</script>

<style>
.full-width {
  width: 100%;
}
</style>
